import { gql } from "@apollo/client";

export const GET_COLLEGE_IPS = gql`
  query getCollegeIpAddresses($filter: CollegeIpAddressFilter!) {
    getCollegeIpAddresses(filter: $filter) {
      id
      collegeObjectId
      ipAddress
      status
      expiry
      collegeName
      stateId
      stateName
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
  }
`;

